
import EoButton from '../EoButton/EoButton.vue'
import EoIcon from '../EoIcon/EoIcon.vue'
import EoTransitionAccordion from '../EoTransitionAccordion/EoTransitionAccordion'

export default {
  name: 'EoCheckboxGroup',
  components: {
    EoButton,
    EoIcon,
    EoTransitionAccordion,
  },
  inheritAttrs: false, // place additional attrs not on container element
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    /**
     * v-model with picked checkbox values
     */
    value: {
      type: Array,
      default: () => [],
    },
    /**
     * Guiding label above the checkbox group
     */
    label: {
      type: String,
      default: null,
      required: true,
    },
    /**
     * Visually hide the label, but make it visible for screen readers
     */
    labelHidden: {
      type: Boolean,
      default: false,
    },
    /**
     * Description of the choice to make (a hint)
     */
    description: {
      type: String,
      default: null,
    },
    /**
     * The name attribute for all checkboxes in it
     */
    name: {
      type: String,
      default: null,
    },
    /**
     * Align checkboxes buttons horizontally
     */
    row: {
      type: Boolean,
      default: false,
    },
    /**
     * Make group vertically collapsible
     */
    collapsible: {
      type: Boolean,
      default: false,
    },
    /**
     * Style: text color
     */
    textColor: {
      type: String,
      default: 'black',
    },
    /**
     * Show the field in error state
     */
    error: {
      type: Boolean,
      default: false,
    },
    /**
     * Array of messages to display
     */
    errorMessages: {
      type: Array,
      default: () => [],
    },
    /**
     * Prevent user interaction with the checkboxes
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      id: null,
      isFocus: false,
      isCollapsed: false,
    }
  },
  computed: {
    classes () {
      return {
        'eo-checkbox-group': true,
        'is-focus': this.isFocus && !this.disabled,
        'is-disabled': this.disabled,
        'is-error': this.error,
        'is-row': this.row,
        'is-collapsible': this.collapsible,
        ['text--' + this.textColor]: !!this.textColor,
      }
    },
    listeners () {
      return {
        ...this.$listeners,
        input: () => {},
        focus: (e) => {
          this.$emit('focus', e)
          this.trackFocus(true)
        },
        blur: (e) => {
          this.$emit('blur', e)
          this.trackFocus(false)
        },
      }
    },
    computedName () {
      return this.name || this.id
    },
    messagesId () {
      return `messages-${this.id}`
    },
  },
  mounted () {
    this.id = this.$attrs.id || `checkboxgroup-${(this.name ? this.name + '-' : '') + this._uid}`
  },
  methods: {
    trackFocus (value) {
      this.isFocus = value
    },
  },
}
